import React, { useEffect, useState } from 'react';
import { Modal } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

export const PendingApprovalModal: React.FC = () => {
  const [shouldDisplayModal, setShouldDisplayModal] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      setShouldDisplayModal(window.localStorage.getItem('pendingApprovalModal') === 'true');
    }
  }, []);

  const removeLocalStoragePendingApproval = () => {
    window.localStorage.removeItem('pendingApprovalModal');
    setShouldDisplayModal(false);
  };

  return (
    <Modal maxWidth="xs" open={shouldDisplayModal}>
      <Modal.Title>Thanks for signing up</Modal.Title>
      <Modal.Content sx={{ fontWeight: 100 }}>
        Your access is currently pending approval by an Account Admin or Full-Access Organizer. You’ll receive an update
        via email soon.
      </Modal.Content>
      <Modal.Actions>
        <Button variant="contained" color="primary" size="medium" onClick={() => removeLocalStoragePendingApproval()}>
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
